
export default {
  name: 'Free',
}
